import { RECEIVE_WALLET_IMG_PATH, SEND_WALLET_IMG_PATH } from '@/consts/imgPath';

interface IProps {
  trxAddress: string;
  sendAddress: string;
}

const SendTransactionInfo = ({ trxAddress, sendAddress }: IProps) => {
  return (
    <div className="transaction-info">
      <div className="address-trs">
        <div className="from">
          <div className="img">
            <img src={SEND_WALLET_IMG_PATH} alt="wallet-img" />
          </div>
          <span className="body-l-n">{trxAddress}</span>
        </div>
        <div className="arrow">
          <img src="img/divisor.png" alt="divisor" />
        </div>
        <div className="to">
          <div className="img">
            <img src={RECEIVE_WALLET_IMG_PATH} alt="wallet-img2" />
          </div>
          <span className="body-l-n">{sendAddress}</span>
        </div>
      </div>
    </div>
  );
};

export default SendTransactionInfo;
